<template>
  <div>
    <AppLoader v-if="isLoading" class="text-center" small />

    <b-row style="height: calc(100vh - 100px);overflow-y:auto;">
      <b-col cols="12">
        <div class="clearfix"></div>

        <div class="p-5">
          <h3>False Positive OGM Remediation&nbsp;</h3>
          <b-tabs>
            <b-tab title="New">
              <b-row class="p-3">
                <b-col cols="3">
                  <b-card footer-tag="footer">
                    <b-row>
                      <b-col cols="8">
                        <b-card-text class="text-right">
                          <strong>Today</strong>
                          <br />
                          <b-card-text style="font-size:50px;" class="text-right text-primary">
                            <number
                              v-if="dataLoadedForStats"
                              ref="number1"
                              :from="0"
                              :to="stats.today"
                              :duration="1"
                              :delay="0"
                              easing="Power1.easeOut"
                            />
                            <span v-else>0</span>
                          </b-card-text>
                        </b-card-text>
                      </b-col>
                      <b-col cols="4">
                        <b-card-text
                          :class="calculatePercentageChange(stats.yesterday,stats.today) > 0 ? 'text-success' : 'text-danger'"
                        >
                          &nbsp;
                          <br />
                          <font-awesome-icon
                            :icon="calculatePercentageChange((stats.yesterday,stats.today)) > 0 ? 'arrow-alt-circle-up' :'arrow-alt-circle-down'"
                          ></font-awesome-icon>
                          {{calculatePercentageChange(stats.yesterday,stats.today)}} %
                        </b-card-text>
                      </b-col>
                    </b-row>

                    <template v-slot:footer>
                      <span class="float-left">Yesterday&nbsp;</span>
                      <b-badge class="float-right" variant="dark" v-if="dataLoadedForStats">
                        <number
                          ref="number2"
                          :from="0"
                          :to="stats.yesterday"
                          :duration="3"
                          :delay="2"
                          easing="Power1.easeOut"
                        />
                      </b-badge>

                      <span v-else>0</span>
                    </template>
                  </b-card>
                </b-col>
                <b-col cols="3">
                  <b-card footer-tag="footer">
                    <b-row>
                      <b-col cols="8">
                        <b-card-text class="text-right">
                          <strong>This Week</strong>
                          <br />
                          <b-card-text style="font-size:50px;" class="text-right text-primary">
                            <number
                              v-if="dataLoadedForStats"
                              ref="number1"
                              :from="0"
                              :to="stats.thisweek"
                              :duration="1"
                              :delay="0"
                              easing="Power1.easeOut"
                            />
                            <span v-else>0</span>
                          </b-card-text>
                        </b-card-text>
                      </b-col>
                      <b-col cols="4">
                        <b-card-text
                          :class="calculatePercentageChange(stats.yesterday,stats.thisweek) > 0 ? 'text-success' : 'text-danger'"
                        >
                          &nbsp;
                          <br />
                          <font-awesome-icon
                            :icon="calculatePercentageChange > 0 ? 'arrow-alt-circle-up' :'arrow-alt-circle-down'"
                          ></font-awesome-icon>
                          {{calculatePercentageChange(stats.yesterday,stats.thisweek)}} %
                        </b-card-text>
                      </b-col>
                    </b-row>

                    <template v-slot:footer>
                      <span class="float-left">Last Week&nbsp;</span>
                      <b-badge class="float-right" variant="dark" v-if="dataLoadedForStats">
                        <number
                          ref="number2"
                          :from="0"
                          :to="stats.lastweek"
                          :duration="3"
                          :delay="2"
                          easing="Power1.easeOut"
                        />
                      </b-badge>

                      <span v-else>0</span>
                    </template>
                  </b-card>
                </b-col>
                <b-col cols="3">
                  <b-card footer-tag="footer">
                    <b-row>
                      <b-col cols="8">
                        <b-card-text class="text-right">
                          <strong>This Month</strong>
                          <br />
                          <b-card-text style="font-size:50px;" class="text-right text-primary">
                            <number
                              v-if="dataLoadedForStats"
                              ref="number1"
                              :from="0"
                              :to="stats.thismonth"
                              :duration="1"
                              :delay="0"
                              easing="Power1.easeOut"
                            />
                            <span v-else>0</span>
                          </b-card-text>
                        </b-card-text>
                      </b-col>
                      <b-col cols="4">
                        <b-card-text
                          :class="calculatePercentageChange(stats.lastmonth,stats.thismonth) > 0 ? 'text-success' : 'text-danger'"
                        >
                          &nbsp;
                          <br />
                          <font-awesome-icon
                            :icon="calculatePercentageChange((stats.lastmonth,stats.thismonth)) > 0 ? 'arrow-alt-circle-up' :'arrow-alt-circle-down'"
                          ></font-awesome-icon>
                          {{calculatePercentageChange(stats.lastmonth,stats.thismonth)}} %
                        </b-card-text>
                      </b-col>
                    </b-row>

                    <template v-slot:footer>
                      <span class="float-left">Last month&nbsp;</span>
                      <b-badge class="float-right" variant="dark" v-if="dataLoadedForStats">
                        <number
                          ref="number2"
                          :from="0"
                          :to="stats.lastmonth"
                          :duration="3"
                          :delay="2"
                          easing="Power1.easeOut"
                        />
                      </b-badge>

                      <span v-else>0</span>
                    </template>
                  </b-card>
                </b-col>
                <b-col cols="3">
                  <b-card footer-tag="footer">
                    <b-row>
                      <b-col cols="8">
                        <b-card-text class="text-right">
                          <strong>This Year</strong>
                          <br />
                          <b-card-text style="font-size:50px;" class="text-right text-primary">
                            <number
                              v-if="dataLoadedForStats"
                              ref="number1"
                              :from="0"
                              :to="stats.thisyear"
                              :duration="1"
                              :delay="0"
                              easing="Power1.easeOut"
                            />
                            <span v-else>0</span>
                          </b-card-text>
                        </b-card-text>
                      </b-col>
                      <b-col cols="4">
                        <b-card-text
                          :class="calculatePercentageChange(stats.lastyear,stats.thisyear) > 0 ? 'text-success' : 'text-danger'"
                        >
                          &nbsp;
                          <br />
                          <font-awesome-icon
                            :icon="calculatePercentageChange((stats.lastyear,stats.thisyear)) > 0 ? 'arrow-alt-circle-up' :'arrow-alt-circle-down'"
                          ></font-awesome-icon>
                          {{calculatePercentageChange(stats.lastyear,stats.thisyear)}} %
                        </b-card-text>
                      </b-col>
                    </b-row>

                    <template v-slot:footer>
                      <span class="float-left">Last Year&nbsp;</span>
                      <b-badge class="float-right" variant="dark" v-if="dataLoadedForStats">
                        <number
                          ref="number2"
                          :from="0"
                          :to="stats.lastyear"
                          :duration="3"
                          :delay="2"
                          easing="Power1.easeOut"
                        />
                      </b-badge>

                      <span v-else>0</span>
                    </template>
                  </b-card>
                </b-col>
              </b-row>
              <b-row class="px-2">
                <b-col cols="12">
                  <b-navbar toggleable="lg" type="dark" variant="light">
                    <b-navbar-brand href="#" class="text-dark">
                      <strong>OGM Remediation</strong>
                    </b-navbar-brand>
                    <b-navbar-nav class="ml-auto">
                      <b-nav-form>
                        <b-form-group
                          label-cols-sm="3"
                          label-align-sm="right"
                          label-size="sm"
                          label-for="filterInput"
                        >
                          <b-input-group size="sm">
                            <b-form-input
                              v-model="newTabFilter"
                              type="search"
                              id="filterInput"
                              placeholder="Type to Search"
                            ></b-form-input>
                            <b-input-group-append>
                              <b-button :disabled="!newTabFilter" @click="newTabFilter = ''">Clear</b-button>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                      </b-nav-form>
                    </b-navbar-nav>
                  </b-navbar>
                  <b-table
                    class="mx-1"
                    sticky-header="calc(100vh - 200px)"
                    ref="table"
                    bordered
                    id="my-table"
                    :busy.sync="isLoading"
                    :items="getNewOgmAlerts"
                    :fields="fields"
                    :filter="newTabFilter"
                    :per-page="newTabPerPage"
                    :current-page="newTabCurrentPage"
                    :sort-by.sync="newTabSortBy"
                    :sort-desc.sync="newTabSortDesc"
                    responsive="sm"
                  >
                    <template v-slot:cell(created_at)="data">
                      <span :id="'tooltip-target-'+data.item.id">{{age(data.item.created_at)}}</span>
                      <b-tooltip
                        :target="'tooltip-target-'+data.item.id"
                        triggers="hover"
                      >{{data.item.created_at}}</b-tooltip>
                    </template>
                    <template v-slot:cell(company_name)="data">{{data.item.company_name || 'N/A' }}</template>
                    <template v-slot:cell(entity_name)="data">
                      <span v-if="data.item.is_associate > 0">
                        <b-badge variant="primary">A</b-badge>&nbsp;
                      </span>
                      {{renderEntityName(data.item)}}
                    </template>

                    <template v-slot:cell(product_type)="data">{{renderProductType(data.item)}}</template>

                    <template v-slot:cell(status)="data">{{renderStatus(data.item)}}</template>
                    <!-- <template v-slot:cell(report_status)="data">
                      <b-badge
                        :variant="renderReportStatusBadge(data.item)"
                      >{{renderReportStatusText(data.item)}}</b-badge>
                    </template>-->
                    <template v-slot:cell(rdc_monitoring_entity_report_alert_count)="data">
                      <b-badge
                        variant="danger"
                        class="text-white"
                      >{{data.item.rdc_monitoring_entity_report_alert_count}}</b-badge>
                    </template>
                    <template v-slot:cell(assigned_to_id)="data">
                      <b-button
                        v-if="data.item.assigned_to_id == 0"
                        variant="primary"
                        @click="showAssigneModal(data.item.id)"
                      >Assign</b-button>
                      <span v-else>{{ data.item.assigned_to_id }}</span>
                      <!-- <span class="btn btn-info btn-circle">NI</span> -->
                    </template>

                    <template v-slot:cell(due_date)="data">
                      <span
                        :id="'tooltip-target-due_date-'+data.item.id"
                      >{{age(data.item.due_date)}}</span>
                    </template>
                    <template v-slot:cell(action)="data">
                      <b-button variant="primary" :to="'/remediation-ogm-alert/'+data.item.id">
                        <font-awesome-icon icon="eye"></font-awesome-icon>
                      </b-button>
                    </template>
                    <template v-slot:cell(download)="data">
                      <a href="#" @click="downloadReport(data)">
                        <font-awesome-icon icon="file-pdf" class="text-danger" size="2x" />
                      </a>
                    </template>
                  </b-table>
                  <b-row>
                    <b-col cols="2">
                      <b-form-select
                        v-model="newTabPerPage"
                        id="perPageSelect"
                        size="sm"
                        :options="newTabPageOptions"
                      ></b-form-select>
                    </b-col>
                    <b-col>
                      <b-pagination
                        class="float-right"
                        v-model="newTabCurrentPage"
                        :total-rows="newTabRows"
                        :per-page="newTabPerPage"
                        first-text="First"
                        prev-text="Prev"
                        next-text="Next"
                        last-text="Last"
                        aria-controls="my-table"
                      ></b-pagination>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="Completed">
              <b-row class="p-3">
                <b-col cols="3">
                  <b-card footer-tag="footer">
                    <b-row>
                      <b-col cols="8">
                        <b-card-text class="text-right">
                          <strong>Today</strong>
                          <br />
                          <b-card-text style="font-size:50px;" class="text-right text-primary">
                            <number
                              v-if="dataLoadedForStats"
                              ref="number1"
                              :from="0"
                              :to="stats.today"
                              :duration="1"
                              :delay="0"
                              easing="Power1.easeOut"
                            />
                            <span v-else>0</span>
                          </b-card-text>
                        </b-card-text>
                      </b-col>
                      <b-col cols="4">
                        <b-card-text
                          :class="calculatePercentageChange(stats.yesterday,stats.today) > 0 ? 'text-success' : 'text-danger'"
                        >
                          &nbsp;
                          <br />
                          <font-awesome-icon
                            :icon="calculatePercentageChange((stats.yesterday,stats.today)) > 0 ? 'arrow-alt-circle-up' :'arrow-alt-circle-down'"
                          ></font-awesome-icon>
                          {{calculatePercentageChange(stats.yesterday,stats.today)}} %
                        </b-card-text>
                      </b-col>
                    </b-row>

                    <template v-slot:footer>
                      <span class="float-left">Yesterday&nbsp;</span>
                      <b-badge class="float-right" variant="dark" v-if="dataLoadedForStats">
                        <number
                          ref="number2"
                          :from="0"
                          :to="stats.yesterday"
                          :duration="3"
                          :delay="2"
                          easing="Power1.easeOut"
                        />
                      </b-badge>

                      <span v-else>0</span>
                    </template>
                  </b-card>
                </b-col>
                <b-col cols="3">
                  <b-card footer-tag="footer">
                    <b-row>
                      <b-col cols="8">
                        <b-card-text class="text-right">
                          <strong>This Week</strong>
                          <br />
                          <b-card-text style="font-size:50px;" class="text-right text-primary">
                            <number
                              v-if="dataLoadedForStats"
                              ref="number1"
                              :from="0"
                              :to="stats.thisweek"
                              :duration="1"
                              :delay="0"
                              easing="Power1.easeOut"
                            />
                            <span v-else>0</span>
                          </b-card-text>
                        </b-card-text>
                      </b-col>
                      <b-col cols="4">
                        <b-card-text
                          :class="calculatePercentageChange(stats.yesterday,stats.thisweek) > 0 ? 'text-success' : 'text-danger'"
                        >
                          &nbsp;
                          <br />
                          <font-awesome-icon
                            :icon="calculatePercentageChange > 0 ? 'arrow-alt-circle-up' :'arrow-alt-circle-down'"
                          ></font-awesome-icon>
                          {{calculatePercentageChange(stats.yesterday,stats.thisweek)}} %
                        </b-card-text>
                      </b-col>
                    </b-row>

                    <template v-slot:footer>
                      <span class="float-left">Last Week&nbsp;</span>
                      <b-badge class="float-right" variant="dark" v-if="dataLoadedForStats">
                        <number
                          ref="number2"
                          :from="0"
                          :to="stats.lastweek"
                          :duration="3"
                          :delay="2"
                          easing="Power1.easeOut"
                        />
                      </b-badge>

                      <span v-else>0</span>
                    </template>
                  </b-card>
                </b-col>
                <b-col cols="3">
                  <b-card footer-tag="footer">
                    <b-row>
                      <b-col cols="8">
                        <b-card-text class="text-right">
                          <strong>This Month</strong>
                          <br />
                          <b-card-text style="font-size:50px;" class="text-right text-primary">
                            <number
                              v-if="dataLoadedForStats"
                              ref="number1"
                              :from="0"
                              :to="stats.thismonth"
                              :duration="1"
                              :delay="0"
                              easing="Power1.easeOut"
                            />
                            <span v-else>0</span>
                          </b-card-text>
                        </b-card-text>
                      </b-col>
                      <b-col cols="4">
                        <b-card-text
                          :class="calculatePercentageChange(stats.lastmonth,stats.thismonth) > 0 ? 'text-success' : 'text-danger'"
                        >
                          &nbsp;
                          <br />
                          <font-awesome-icon
                            :icon="calculatePercentageChange((stats.lastmonth,stats.thismonth)) > 0 ? 'arrow-alt-circle-up' :'arrow-alt-circle-down'"
                          ></font-awesome-icon>
                          {{calculatePercentageChange(stats.lastmonth,stats.thismonth)}} %
                        </b-card-text>
                      </b-col>
                    </b-row>

                    <template v-slot:footer>
                      <span class="float-left">Last month&nbsp;</span>
                      <b-badge class="float-right" variant="dark" v-if="dataLoadedForStats">
                        <number
                          ref="number2"
                          :from="0"
                          :to="stats.lastmonth"
                          :duration="3"
                          :delay="2"
                          easing="Power1.easeOut"
                        />
                      </b-badge>

                      <span v-else>0</span>
                    </template>
                  </b-card>
                </b-col>
                <b-col cols="3">
                  <b-card footer-tag="footer">
                    <b-row>
                      <b-col cols="8">
                        <b-card-text class="text-right">
                          <strong>This Year</strong>
                          <br />
                          <b-card-text style="font-size:50px;" class="text-right text-primary">
                            <number
                              v-if="dataLoadedForStats"
                              ref="number1"
                              :from="0"
                              :to="stats.thisyear"
                              :duration="1"
                              :delay="0"
                              easing="Power1.easeOut"
                            />
                            <span v-else>0</span>
                          </b-card-text>
                        </b-card-text>
                      </b-col>
                      <b-col cols="4">
                        <b-card-text
                          :class="calculatePercentageChange(stats.lastyear,stats.thisyear) > 0 ? 'text-success' : 'text-danger'"
                        >
                          &nbsp;
                          <br />
                          <font-awesome-icon
                            :icon="calculatePercentageChange((stats.lastyear,stats.thisyear)) > 0 ? 'arrow-alt-circle-up' :'arrow-alt-circle-down'"
                          ></font-awesome-icon>
                          {{calculatePercentageChange(stats.lastyear,stats.thisyear)}} %
                        </b-card-text>
                      </b-col>
                    </b-row>

                    <template v-slot:footer>
                      <span class="float-left">Last Year&nbsp;</span>
                      <b-badge class="float-right" variant="dark" v-if="dataLoadedForStats">
                        <number
                          ref="number2"
                          :from="0"
                          :to="stats.lastyear"
                          :duration="3"
                          :delay="2"
                          easing="Power1.easeOut"
                        />
                      </b-badge>

                      <span v-else>0</span>
                    </template>
                  </b-card>
                </b-col>
              </b-row>
              <b-row class="px-2">
                <b-col cols="12">
                  <b-navbar toggleable="lg" type="dark" variant="light">
                    <b-navbar-brand href="#" class="text-dark">
                      <strong>OGM Remediation</strong>
                    </b-navbar-brand>
                    <b-navbar-nav class="ml-auto">
                      <b-nav-form>
                        <b-form-group
                          label-cols-sm="3"
                          label-align-sm="right"
                          label-size="sm"
                          label-for="filterInput"
                        >
                          <b-input-group size="sm">
                            <b-form-input
                              v-model="filter"
                              type="search"
                              id="filterInput"
                              placeholder="Type to Search"
                            ></b-form-input>
                            <b-input-group-append>
                              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                      </b-nav-form>
                    </b-navbar-nav>
                  </b-navbar>
                  <b-table
                    class="mx-1"
                    sticky-header="calc(100vh - 200px)"
                    ref="table"
                    bordered
                    id="my-table"
                    :busy.sync="isLoading"
                    :items="getCompletedOgmAlerts"
                    :fields="completedFields"
                    :filter="filter"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    responsive="sm"
                  >
                    age
                    <template v-slot:cell(created_at)="data">
                      <span :id="'tooltip-target-'+data.item.id">{{age(data.item.created_at)}}</span>
                      <b-tooltip
                        :target="'tooltip-target-'+data.item.id"
                        triggers="hover"
                      >{{data.item.created_at}}</b-tooltip>
                    </template>
                    <template v-slot:cell(company_name)="data">{{data.item.company_name || 'N/A' }}</template>
                    <template v-slot:cell(entity_name)="data">
                      <span v-if="data.item.is_associate > 0">
                        <b-badge variant="primary">A</b-badge>&nbsp;
                      </span>
                      {{renderEntityName(data.item)}}
                    </template>

                    <template v-slot:cell(product_type)="data">{{renderProductType(data.item)}}</template>

                    <template v-slot:cell(status)="data">{{renderStatus(data.item)}}</template>
                    <!-- <template v-slot:cell(report_status)="data">
                      <b-badge
                        :variant="renderReportStatusBadge(data.item)"
                      >{{renderReportStatusText(data.item)}}</b-badge>
                    </template>-->
                    <template v-slot:cell(rdc_monitoring_entity_report_alert_count)="data">
                      <b-badge
                        variant="danger"
                        class="text-white"
                      >{{data.item.rdc_monitoring_entity_report_alert_count}}</b-badge>
                    </template>
                    <template v-slot:cell(assigned_to_id)="data">
                      <b-button
                        v-if="data.item.assigned_to_id == 0"
                        variant="primary"
                        @click="showAssigneModal(data.item.id)"
                      >Assign</b-button>
                      <span v-else>{{ data.item.assigned_to_id }}</span>
                      <!-- <span class="btn btn-info btn-circle">NI</span> -->
                    </template>

                    <template v-slot:cell(due_date)="data">
                      <span
                        :id="'tooltip-target-due_date-'+data.item.id"
                      >{{age(data.item.due_date)}}</span>
                    </template>
                    <template v-slot:cell(action)="data">
                      <b-button variant="primary" :to="'/remediation-ogm-alert/'+data.item.id">
                        <font-awesome-icon icon="eye"></font-awesome-icon>
                      </b-button>
                    </template>
                    <template v-slot:cell(download)="data">
                      <a href="#" @click="downloadReport(data)">
                        <font-awesome-icon icon="file-pdf" class="text-danger" size="2x" />
                      </a>
                    </template>
                  </b-table>
                  <b-row>
                    <b-col cols="2">
                      <b-form-select
                        v-model="perPage"
                        id="perPageSelect"
                        size="sm"
                        :options="pageOptions"
                      ></b-form-select>
                    </b-col>
                    <b-col>
                      <b-pagination
                        class="float-right"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        first-text="First"
                        prev-text="Prev"
                        next-text="Next"
                        last-text="Last"
                        aria-controls="my-table"
                      ></b-pagination>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </div>
      </b-col>
    </b-row>
    <b-modal
      id="my-modal"
      no-close-on-backdrop
      hide-header
      v-model="showAssignedToModal"
      @ok="submitModal"
    >
      <b-form-group label="Assign to Client">
        <v-select
          :searchable="false"
          :clearable="true"
          aria-describedby
          v-model="selected"
          :options="clientsOptions"
          placeholder="Please Select Client"
          @input="selctLabel"
        >
          <template slot="option" slot-scope="option">
            <span>{{ '&nbsp;'+ option.ibf_member.name }}</span>
          </template>
        </v-select>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import { HTTP } from "../utils/HTTP";
import axios from "axios";
import config from "./../configs/config";
import { Helper } from "../helpers";
import AppLoader from "../components/Loader/Loader";

import vSelect from "vue-select";
// import _ from "lodash";
// import uid from "uid";
import moment from "moment";
import "moment/locale/es";

export default {
  name: "remediationAsAServiceOgm",
  components: {
    vSelect,

    AppLoader
  },
  data() {
    return {
      reportRowId: null,
      userId: null,
      selected: null,
      clientsOptions: [],
      showAssignedToModal: false,
      mainProps: {
        blank: true,
        width: 40,
        height: 40,
        class: "m1"
      },
      dataLoadedForStats: false,
      stats: {
        today: 0,
        yesterday: 0,
        thisweek: 0,
        lastweek: 0,
        thismonth: 0,
        lastmonth: 0,
        thisyear: 0,
        lastyear: 0
      },
      newTabPerPage: 10,
      newTabTotalRows: 0,
      newTabCurrentPage: 1,
      newTabSortBy: "created_at",
      newTabSortDesc: true,
      newTabPageOptions: [5, 10, 25, 50, 75, 100],
      newTabFilter: null,
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      sortBy: "created_at",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      filter: null,
      totalAlerts: 0,
      isLoading: false,
      dataLoaded: false,
      items: [],
      fields: [
        { key: "created_at", label: "Age", sortable: true },
        { key: "product_type", label: "Service", sortable: true },
        { key: "company_name", label: "Client", sortable: true },
        { key: "entity_name", label: "Entity Name", sortable: false },
        { key: "rdc_monitoring_entity_report_alert_count", label: "No. Alerts", sortable: false },
        { key: "assigned_to_id", label: "Assigned To", sortable: false },
        { key: "due_date", label: "Due date", sortable: false },
        { key: "status", label: "Status", sortable: false },
        // { key: "report_status", label: "Outcome", sortable: false },
        { key: "action", label: "Actions", sortable: false },
        { key: "download", label: "Report", sortable: false }
      ],
      completedFields: [
        { key: "created_at", label: "Age", sortable: true },
        { key: "product_type", label: "Service", sortable: true },
        { key: "company_name", label: "Client", sortable: true },
        { key: "entity_name", label: "Entity Name", sortable: false },
        { key: "rdc_monitoring_entity_report_alert_count", label: "No. Alerts", sortable: false },
        { key: "assigned_to_id", label: "Assigned To", sortable: false },
        { key: "completed_at", label: "Completed On", sortable: false },
        // { key: "report_status", label: "Outcome", sortable: false },
        { key: "action", label: "Actions", sortable: false },
        { key: "download", label: "Report", sortable: false }
      ]
    };
  },
  computed: {
    newTabRows() {
      return this.newTabTotalRows;
    },
    rows() {
      return this.totalRows;
    }
  },
  mounted() {
    this.getOgmStats();
  },
  methods: {
    reloadTable() {
      this.$root.$emit("bv::refresh::table", "my-table");
    },
    selctLabel(value) {
      this.selected = value.ibf_member.name;
      this.userId = value.userId;
    },
    async getassigneesdata() {
      this.clientsOptions = [];
      let token = "Bearer " + localStorage.getItem("accessToken");
      try {
        let result = await HTTP("get", "v1/remediation/assignees", null, {
          Authorization: token
        });
        this.clientsOptions = result.data;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    },
    showAssigneModal(data) {
      this.getassigneesdata();
      this.showAssignedToModal = true;
      this.reportRowId = data;
    },
    submitModal() {
      let formData = {
        userId: this.userId,
        reportId: this.reportRowId
      };

      this.totalAlerts = 0;
      let token = "Bearer " + localStorage.getItem("accessToken");
      this.isLoading = true;
      let result = HTTP("post", "v1/remediation/assignto", formData, {
        Authorization: token
      });

      return result
        .then(response => {
          this.isLoading = false;
          this.reloadTable();
        })
        .catch(error => {
          return [];
        });
    },
    calculatePercentageChange(previousData, newData) {
      let percentageChange =
        ((parseInt(newData) - parseInt(previousData)) /
          parseInt(previousData)) *
        100;
      return percentageChange.toFixed(0);
    },
    age(value) {
      moment.locale("en");
      // // console.log(value);
      // let localeData = moment.updateLocale("en", {
      // 	relativeTime: {
      // 		future: "in %s",
      // 		past: "%s ago",
      // 		s: "hello, a few seconds",
      // 		ss: "%d seconds",
      // 		m: "a minute",
      // 		mm: "%d minutes",
      // 		h: "an hour",
      // 		hh: "%d hours",
      // 		d: "a day",
      // 		dd: "%d days",
      // 		M: "a month",
      // 		MM: "%d months",
      // 		y: "a year",
      // 		yy: "%d years"
      // 	}
      // });
      //return moment(value).fromNow();
      return moment.utc(value).fromNow();
    },
    theFormat(number) {
      return number.toFixed(2);
    },
    completed() {
      // console.log("Animation ends!");
    },
    playAnimation() {
      this.$refs.number2.play();
    },
    renderEntityName(item) {
      let entityName = "";
      if (item.is_associate == 1) {
        entityName =
          item.srch_tpi_asso.asso_name +
          " (" +
          item.shield_vendor_info.comp_name_eng +
          ")";
      } else {
        entityName = item.shield_vendor_info.comp_name_eng;
      }
      return entityName;
    },
    renderAlertAgainst(item) {
      let alertAgainst = "Third Party";
      if (item.is_associate == 1) {
        alertAgainst = "Associate";
      }
      return alertAgainst;
    },
    renderProductType(item) {
      let productType = "IDD Plus";
      if (item.product_type == 1) {
        productType = "IDD";
      }
      return productType;
    },
    renderStatus(item) {
      let status = "Un Assigned";
      if (item.status == 1) {
        status = "Assigned";
      }
      return status;
    },
    // renderReportStatusText(item) {
    //   let status = "Pending";
    //   if (item.status == 1) {
    //     status = "Negative";
    //   } else if (item.status == 2) {
    //     status = "Positive";
    //   }
    //   return status;
    // },
    // renderReportStatusBadge(item) {
    //   let status = "primary";
    //   if (item.status == 1) {
    //     status = "success";
    //   } else if (item.status == 2) {
    //     status = "danger";
    //   }
    //   return status;
    // },
    renderAssignedTo(item) {
      let status = "Not Assigned";
      if (item.status == 1) {
        status = "Assigned";
      }
      return status;
    },
    async getNewOgmAlerts() {
      let formData = {
        filter: this.newTabFilter,
        sort:
          this.newTabSortBy +
          "|" +
          (this.newTabSortDesc == true ? "desc" : "asc"),
        per_page: this.newTabPerPage,
        page: this.newTabCurrentPage
      };

      let token = "Bearer " + localStorage.getItem("accessToken");
      this.isLoading = true;
      let result = HTTP("post", "v1/remediation/admin/ogm/0", formData, {
        Authorization: token
      });

      return result
        .then(response => {
          const items = response.data.data;
          // console.log(response.data.data);
          this.dataLoaded = true;
          this.isLoading = false;
          this.newTabTotalRows = response.data.total;
          return items;
        })
        .catch(error => {
          this.isLoading = false;
          this.showErrorToast = true;
          return [];
        });
    },
    async getCompletedOgmAlerts() {
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + (this.sortDesc == true ? "desc" : "asc"),
        per_page: this.perPage,
        page: this.currentPage
      };

      let token = "Bearer " + localStorage.getItem("accessToken");
      this.isLoading = true;
      let result = HTTP("post", "v1/remediation/admin/ogm/1", formData, {
        Authorization: token
      });

      return result
        .then(response => {
          const items = response.data.data;

          this.dataLoaded = true;
          this.isLoading = false;
          this.totalRows = response.data.total;
          return items;
        })
        .catch(error => {
          this.isLoading = false;
          this.showErrorToast = true;
          return [];
        });
    },
    async getOgmStats() {
      let token = "Bearer " + localStorage.getItem("accessToken");
      this.isLoading = true;
      let result = HTTP(
        "get",
        "v1/remediation/ogm/stats",
        {},
        {
          Authorization: token
        }
      );

      return result
        .then(response => {
          this.dataLoadedForStats = true;
          this.stats = response.data;
        })
        .catch(error => {
          this.isLoading = false;
          this.showErrorToast = true;
          return [];
        });
    },

    makeToast() {
      const h = this.$createElement;
      const vNodesMsg = h(
        "p",
        {
          class: ["text-center", "mb-0"]
        },
        [
          h("b-spinner", {
            props: {
              type: "grow",
              small: true
            }
          }),
          " We are generating your PDF... ",
          h("b-spinner", {
            props: {
              type: "grow",
              small: true
            }
          })
        ]
      );
      this.$bvToast.toast([vNodesMsg], {
        variant: "warning",
        title: "PDF",
        autoHideDelay: 3000
      });
    },

    downloadReport(data) {
      let titleForm = data.item.shield_vendor_info.comp_name_eng+".pdf";
      this.makeToast();
      axios({
        url: config.API_URL + "v1/remediation/ogm/download/report",
        method: "POST",
        responseType: "blob", // important
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken")
        },
        data: {
          thirdpartyid: data.item.third_party_id,
          companyid: data.item.company_id,
          rdcMonitoringId: data.item.id,
          productType: data.item.product_type,
          userId: localStorage.getItem("userId")
        }
      })
        .then(response => {
          if (window.navigator.msSaveOrOpenBlob) {
            // let blob = response.data.blob;
            let blob = new Blob([response.data]);
            // IE11
            window.navigator.msSaveOrOpenBlob(blob, titleForm);
            Helper.makeToast(
              this.$bvToast,
              "success",
              "PDF download successfully"
            );
            return;
          } else {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", titleForm); //or any other extension
            document.body.appendChild(link);
            link.click();
            if (response) {
              Helper.makeToast(
                this.$bvToast,
                "success",
                "PDF download successfully"
              );
            }
          }
        })
        .catch(error => {
          Helper.makeToast(
            this.$bvToast,
            "danger",
            "PDF not downloaded please try again"
          );
        });
    }
  }
};
</script>

<style scoped>
.btn-circle {
  width: 30px;
  height: 30px;
  padding: 6px 0px;
  border-radius: 15px;
  text-align: center;

  line-height: 1.42857;
}
</style>
